var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('layout',{attrs:{"name":"Sidebar","extraClass":"csv-history-layout"}},[_c('VTableView',{attrs:{"sidebar":{
      buttons: _vm.buttons,
      title: 'Import History',
      extraClass: 'import-history-layout-heading'
    },"with-pagination":_vm.total && _vm.total > 25}},[_c('template',{slot:"search"},[_c('ContactsImportHistoryFilter')],1),_c('template',{slot:"table"},[_c('ContactsCSVHistoryTable',{attrs:{"extraClass":"csv-history-table"}})],1),_c('template',{slot:"pagination"},[_c('ContactsImportHistoryPagination')],1)],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }